import { Dialog } from "@mui/material";
import classNames from "classnames";
import { memo } from "react";
import * as css from "./merchant-customizable-modal.module.css";

export const MerchantCustomizableModal = memo(
  function MerchantCustomizableModal({
    open,
    onClose,
    children,
    fullscreen,
    backdropColor,
  }: {
    open: boolean;
    onClose: () => void;
    children?: React.ReactNode;
    fullscreen: boolean;
    backdropColor?: string;
  }) {
    const stopPropagation = (e: React.MouseEvent) => {
      e.stopPropagation();
    };

    return (
      <>
        <style>{`.MuiBackdrop-root{background-color: ${backdropColor};}`}</style>
        <Dialog
          className={css.modalWrapper}
          onClose={(_, reason) => {
            if (reason !== "backdropClick") {
              onClose();
            }
          }}
          open={open}
        >
          <div className={classNames(fullscreen ? css.fullscreen : "")}>
            <div
              className={fullscreen ? css.fullscreen : ""}
              onClick={stopPropagation}
            >
              {children}
            </div>
          </div>
        </Dialog>
      </>
    );
  },
);
